var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D8C041"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.342 16.3399C16.81 16.3399 17.2108 16.1732 17.5441 15.8399C17.8774 15.5065 18.0441 15.1058 18.0441 14.6377C18.0441 14.1696 17.8774 13.7689 17.5441 13.4356C17.2108 13.1023 16.81 12.9356 16.342 12.9356C15.8739 12.9356 15.4732 13.1023 15.1398 13.4356C14.8065 13.7689 14.6398 14.1696 14.6398 14.6377C14.6398 15.1058 14.8065 15.5065 15.1398 15.8399C15.4732 16.1732 15.8739 16.3399 16.342 16.3399ZM16.342 22.5952C18.0725 21.0065 19.3561 19.5633 20.193 18.2654C21.0299 16.9675 21.4483 15.815 21.4483 14.8079C21.4483 13.2618 20.9554 11.9959 19.9696 11.0101C18.9838 10.0243 17.7746 9.53135 16.342 9.53135C14.9093 9.53135 13.7001 10.0243 12.7143 11.0101C11.7285 11.9959 11.2356 13.2618 11.2356 14.8079C11.2356 15.815 11.654 16.9675 12.4909 18.2654C13.3278 19.5633 14.6115 21.0065 16.342 22.5952ZM16.342 24.8505C14.0583 22.9072 12.3526 21.1023 11.2249 19.4356C10.0973 17.7689 9.53345 16.2264 9.53345 14.8079C9.53345 12.6803 10.2178 10.9853 11.5866 9.72284C12.9554 8.46043 14.5405 7.82922 16.342 7.82922C18.1434 7.82922 19.7285 8.46043 21.0973 9.72284C22.4661 10.9853 23.1505 12.6803 23.1505 14.8079C23.1505 16.2264 22.5866 17.7689 21.459 19.4356C20.3313 21.1023 18.6256 22.9072 16.342 24.8505Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetLocationIcon);
export default __webpack_public_path__ + "static/media/asset_location_icon.76da8e53e85ff1a0833add96ea68c19d.svg";
export { ForwardRef as ReactComponent };